import InAppStat from './InAppStats';

export default InAppStat;
